/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type HomeGrid_grid$ref = any;
type HomeLookBook_lookbook$ref = any;
type LandingpageDescription_info$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HomeGrid_viewer$ref: FragmentReference;
export type HomeGrid_viewer = {|
  +landingPage: ?$ReadOnlyArray<?{|
    +id: string,
    +$fragmentRefs: HomeLookBook_lookbook$ref & HomeGrid_grid$ref & LandingpageDescription_info$ref,
  |}>,
  +$refType: HomeGrid_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HomeGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "landingPage",
      "storageKey": null,
      "args": null,
      "concreteType": "RangeNode",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HomeLookBook_lookbook",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HomeGrid_grid",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "LandingpageDescription_info",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b2c6fd180b9e5e32f243fc9967c967bd';
module.exports = node;
